import type { FC } from "react";
import { ActivityListRow } from "web_myplann/Activities/Components/ActivityListRow";
import { TaskListRow } from "web_myplann/Activities/Components/TaskListRow";
import {
	type ActivityOrTaskListItem,
	isActivityListItem,
} from "web_myplann/Activities/Helpers/isActivityListItem";
import { EventRowVariant } from "web_myplann/Shared/Types/EventRowVariant";

type Props = {
	item: ActivityOrTaskListItem;
	showDivider: boolean;
	showPerson: boolean;
	variant?: EventRowVariant;
};

export const ActivityGroupRow: FC<Props> = ({
	item,
	showDivider,
	showPerson,
	variant = EventRowVariant.List,
}) =>
	isActivityListItem(item) ? (
		<ActivityListRow
			data={item}
			showDivider={showDivider}
			showPerson={showPerson}
		/>
	) : (
		<TaskListRow
			data={item}
			variant={variant}
			showDivider={showDivider}
			showPerson={showPerson}
		/>
	);
